module.exports = __webpack_public_path__ + "img/Icon ionic-ios-leaf.52ac8c69.svg";